import { render, staticRenderFns } from "./DeleteButtonDisabled.vue?vue&type=template&id=8b771230&"
import script from "./DeleteButtonDisabled.vue?vue&type=script&lang=js&"
export * from "./DeleteButtonDisabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports